import { TextMap } from "../../types";

const ko: TextMap = {
  choose_preferred_wallet: "원하는 지갑을 선택하세요",
  connect_mobile_wallet: "모바일 지갑과 연결",
  scan_qrcode_with_wallet: "WalletConnect 지원 지갑에서 QR코드를 스캔하세요",
  connect: "연결",
  // TODO: review following translations
  qrcode: "QR 코드",
  mobile: "모바일",
  copy_to_clipboard: "클립보드에 복사",
  copied_to_clipboard: "클립보드에 복사되었습니다!",
  show_more: "자세히 보기",
  show_less: "간략히 보기",
};

export default ko;
